<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <div @click="jumpToSight(item.linkId)" class="line-cont">
            <div class="v-line-desc text-overflow">
              {{ item.desc }}
            </div>
          </div>
          <div @click="jumpToSight(item.linkId)" class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div v-maidian="'line_' + index" class="line-btm clear">
            <div class="price">
              <span class="price-ticket">票数{{ item.note }}票</span>
              <mt-button @click="userVote(item.code)" size="small"
                >投票</mt-button
              >
            </div>
          </div>
        </div>
        <div class="bg-line"></div>
      </div>
    </div>
    <!-- <img class="tip"
      src="https://s.qunarzz.com/srmweb/qunaradv/changma202203/29.png"
      alt=""
    /> -->
  </div>
</template>
<script>
import giftDialog from './dialog/gift/gift';
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/22159bb7-ceb8-402d-a98c-909ab53b5290.jpg_r_640x420x95_2b416cc8.jpg',
            code: 'JHG',
            note: 0,
            desc: '自由行 【自营·泼水节/五一提前购】西双版纳融创皇冠假日高级房连住2晚（含双早+非遗体验+双人告庄傣式精美旅拍+接机/接站一次）',
            linkId:
              'https://qnel1.package.qunar.com/user/detail.jsp?abt=a&id=3164114731&',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/c8918404-5437-4ebe-a2bc-6edf096cd106.jpg_r_640x420x95_7bd5f11e.jpg',
            note: 0,
            code: 'XJ',
            desc: '新疆北疆+乌鲁木齐+喀纳斯+禾木+可可托海+天山天池+五彩滩+魔鬼城8日7晚私家团',
            linkId: 'https://touch.dujia.qunar.com/p/item/3981361570?',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/990336c6-99f9-40ca-af7d-666ae225d1d1.jpg_r_640x420x95_0e99ed7e.jpg',
            desc: '亚特兰蒂斯海景房+畅玩水世界、水乐园+大东海哈曼3晚🏊打卡网红无边泳池',
            note: 0,
            code: 'SY',
            linkId: 'https://touch.dujia.qunar.com/p/item/1614140760?',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/ff86a30d-ac96-4a3f-9464-a4327f2d326e.jpg_r_640x420x95_4c73ad22.jpg',
            desc: '【全程五钻·精致15人团】丽江+大理+香格里拉6日普达措+壮丽虎跳峡+玉龙雪山冰川大索+梦回南诏+双廊+网红理想帮',
            note: 0,
            code: 'XGLLG',
            linkId: 'https://touch.dujia.qunar.com/p/item/3007949792?',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/d34bceda-4da6-4f3b-97d2-8c4acfb9063b.jpg_r_640x420x95_d7ace8e1.jpg',
            desc: '「去哪自营·私享+」纯玩漫游·丽江大理香格里拉',
            note: 0,
            code: 'XGLLS',
            linkId: 'https://touch.dujia.qunar.com/p/item/3500278936?',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/50df8c98-2bc1-460a-a89d-02affa5ee232.jpg_r_640x420x95_5fb61904.jpg',
            desc: '西宁出发-私家团 纯玩0购住6晚4鉆酒店私家团专车接送+🌸青甘大环线7天🌸288元沙漠露营|青海湖+翡翠湖+敦煌莫高窟+张掖',
            note: 0,
            code: 'QG',
            linkId: 'https://touch.dujia.qunar.com/p/item/210051152?',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20230414-shijianchen-yao-img1.jpeg',
            desc: '拉萨出发-跟团游 徒步西藏阿里南线2至6人10日游；徒步转山冈仁波齐；拉萨+珠峰大本营+日喀则',
            note: 0,
            code: 'LS',
            linkId: 'https://touch.dujia.qunar.com/p/item/46675291?',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/eab78436-525b-41a3-bdbb-02807ebb4230.jpg_r_640x420x95_90326760.jpg',
            desc: '广州出发-跟团游 五一亲子乐园•广州长隆+珠海长隆+市游5天游 品广式点心餐•赠珠江夜游',
            note: 0,
            code: 'GZ',
            linkId: 'https://touch.dujia.qunar.com/p/item/2949552841?',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/03bd7751-87b0-415a-83f3-31aa30c1495e.jpg_r_640x420x95_435380b4.jpg',
            desc: '上海出发-跟团游 上海迪士尼乐园+苏州+乌镇+杭州5日游丨五星旅行社 精致慢游丨豪华品牌酒店 享自助早餐丨含4早3正 餐标50元丨轻松游',
            note: 0,
            code: 'HD',
            linkId: 'https://touch.dujia.qunar.com/p/item/694492752?',
          },
        ],
      ],
    };
  },
  mounted() {
    this.allVote();
    // giftDialog({});
  },
  methods: {
    jumpToSight(linkId) {
      location.href = linkId;
    },
    allVote() {
      this.commonAjax({
        url: '/commonly/allVote',
        method: 'get',
        success: (data) => {
          this.lineList[0].forEach((item) => {
            data.forEach((child) => {
              if (item.code == child.categoryCode) {
                item.note = child.voteCount;
              }
            });
          });
        },
      });
    },
    userVote(categoryCode) {
      this.commonAjax({
        url: '/commonly/userVote?categoryCode=' + categoryCode,
        method: 'get',
        success: (data) => {
          this.commonAjax({
            url: '/commonly/v2/lottery',
            method: 'post',
            success: (data) => {
              giftDialog({
                giftTip: data.code,
              });
            },
          });
          this.allVote();
        },
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  top: -36px;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  padding-top: 21px;
  &-box {
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 24px);
    box-sizing: border-box;
    border-radius: 3px;
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    border-radius: 10px;
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 190px;
      height: 234px;

      background: url(https://source.qunarzz.com/site/images/wns/20230414-shijianchen-right.png)
        no-repeat;
      background-size: 100% auto;
      position: absolute;
      right: -18px;
      bottom: -18px;
    }
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 158px;
    background-color: #fff;
    float: left;
    z-index: 2;
    padding-top: 20px;
    box-sizing: border-box;
    &-box {
      position: relative;
      margin-bottom: 7px;
      &:last-child {
        margin-bottom: 0;
      }
      // .bg-line {
      //     background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
      //         no-repeat;
      //     background-size: 100% auto;
      //     height: 20px;
      //     width: 100%;
      //     position: absolute;
      //     left: 0;
      //     bottom: 7px;
      // }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 7px;
    padding-top: 2px;
    padding-bottom: 0;
  }
  &-btm {
    padding: 7px 7px 7px 0;
    .price {
      &-ticket {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        float: left;
        color: #aaa9a9;
        font-size: 12px;
        position: relative;
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    img {
      display: block;
      height: 95px;
      width: 100%;
    }
  }
  .price {
    display: flex;
    align-items: center;
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background-color: #d94f40;
    border-radius: 6px;
    color: #fff;
    font-size: 11px;
    height: 24px;
    margin-left: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
.line-cont {
  padding: 8px 0;
}
.line-cont-desc {
  font-size: 11px;
  color: #666;
  text-align: left;
  margin-top: 4px;
}
.v-line-desc {
  text-align: left;
  // height: 40px;
  font-size: 15px;
}
.tip {
  width: 280px;
  display: block;
  margin: 0 auto;
}
</style>